import { getAppEndpointVersion } from 'helpers'
import constants from '../../constants'
import axios from '../axiosInstance'

export async function list(app: any, apiHost: string, pageNo = 1, searchText = '') {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/roles?per_page=${
    constants.perPageInListings
  }&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      params: { page: pageNo, searchKey: searchText, _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error?.response?.data ?? Promise.reject(error)
    })
}

export async function get(id: string, app: any, apiHost: string) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/roles/${id}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error?.response?.data ?? Promise.reject(error)
    })
}

export async function add(post: any, app: any, apiHost: string) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/roles`
  return axios
    .post(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error?.response?.data ?? Promise.reject(error)
    })
}

export async function search(app: any, apiHost: string, searchText: string, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/roles?per_page=${
    constants.perPageInListings
  }&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      params: { page: pageNo, searchKey: searchText },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error?.response?.data ?? Promise.reject(error)
    })
}

export async function del(id: string, app: any, apiHost: string) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/roles/${id}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error?.response?.data ?? Promise.reject(error)
    })
}

export async function update(id: string, post: any, app: any, apiHost: string) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/roles/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error?.response?.data ?? Promise.reject(error)
    })
}
